import { CmdHandler } from '@/config/cmd';
import CmdEnum from '@/constants/CmdEnum';
import AppStore from '@/store/App';
import OSStore from '@/store/OS';
import ClipboardManager from './Clipboard';
import HistoryManager from './History';

export default class CmdManager {
  // 命令集合
  private static cmds: Map<CmdEnum, CmdHandler[]> = new Map();

  /**
   * 注册所有命令
   * @param cmd 命令名称
   * @param handle 执行钩子
   */
  static register(cmd: CmdEnum, handle: CmdHandler) {
    const handlers = CmdManager.cmds.get(cmd) || [];
    handlers.push(handle);
    CmdManager.cmds.set(cmd, handlers);
  }

  /**
   * 执行命令
   * @param cmd 命令名称
   * @param data 额外传入的数据
   */
  static execute(cmd: CmdEnum, data?: any) {
    const handlers = CmdManager.cmds.get(cmd) || [];
    handlers.forEach(handle => handle(data));
  }

  /**
   * 检查命令是否已经注册
   * @param cmd 命令名称
   * @returns {boolean}
   */
  static has(cmd: CmdEnum): boolean {
    return CmdManager.cmds.has(cmd);
  }
}

/**
 * 注册相关命令
 */
function registerCmds(cmds: Record<string, CmdHandler>) {
  for (const key in cmds) {
    CmdManager.register(+key, cmds[key]);
  }
}

/**
 * 注册作品相关动作命令
 * @param app 作品数据
 */
export function registerAppActions(app: AppStore) {
  const cmdToAction: Record<string, CmdHandler> = {
    [CmdEnum.SAVE]() {
      app.save();
    },
    [CmdEnum.COPY]() {
      app.copyCmps();
      ClipboardManager.copyToClipboard();
    },
    [CmdEnum.CUT]() {
      app.cutCmps();
      ClipboardManager.copyToClipboard();
    },
    [CmdEnum.PASTE]() {
      app.pasteCmps();
    },
    [CmdEnum.DELETE]() {
      app.removeCmp(app.activedCmps);
    },
    [CmdEnum['SELECT ALL']]() {
      // app.activeCmp(app.activedScene.cmps);
    },
    [CmdEnum['TO UP']]() {
      app.moveCmpBy(-1, 'top');
    },
    [CmdEnum['TO BUTTOM']]() {
      app.moveCmpBy(1, 'top');
    },
    [CmdEnum['TO UP 10PX']]() {
      app.moveCmpBy(-10, 'top');
    },
    [CmdEnum['TO BUTTOM 10PX']]() {
      app.moveCmpBy(10, 'top');
    },
    [CmdEnum['TO LEFT']]() {
      app.moveCmpBy(-1, 'left');
    },
    [CmdEnum['TO RIGHT']]() {
      app.moveCmpBy(1, 'left');
    },
    [CmdEnum['TO LEFT 10PX']]() {
      app.moveCmpBy(-10, 'left');
    },
    [CmdEnum['TO RIGHT 10PX']]() {
      app.moveCmpBy(10, 'left');
    },
  };

  registerCmds(cmdToAction);
}

/**
 * 注册系统设置相关动作命令
 * @param OS 系统设置
 */
export function registerOSSActions(OS: OSStore) {
  const cmdToAction: Record<string, CmdHandler> = {
    [CmdEnum['ZOOM IN']]() {
      OS.zoomIn();
    },
    [CmdEnum['ZOOM OUT']]() {
      OS.zoomOut();
    },
  };

  registerCmds(cmdToAction);
}

/**
 * 注册操作记录相关动作命令
 */
export function registerHistoryActions() {
  const cmdToAction: Record<string, CmdHandler> = {
    [CmdEnum.UNDO]() {
      HistoryManager.undo();
    },
    [CmdEnum.REDO]() {
      HistoryManager.redo();
    },
  };

  registerCmds(cmdToAction);
}
